import { useContext, useEffect } from 'react'
import moment from 'moment-timezone'
import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import { DataContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain } from '../../services/constants'
import { sendViewAnalytics } from '../common/util/util'

export default function SystemInfo() {
  const border = custom.border
  const data = useContext(DataContext)

  useEffect(() => {
    sendViewAnalytics('/profile', {
      domain: analyticsDomain.profile,
      name: analyticsPage.systemProfile,
    })
  }, [])

  return (
    <Box
      px={custom.spacing.md}
      pt={{
        xs: custom.spacing.xxl,
        sm: data?.rightPanel ? custom.spacing.md : 0,
        md: 0,
        lg: 0,
      }}>
      <Paper
        elevation={0}
        id={'SystemInformation'}
        sx={{
          borderRadius: custom.corners4,
          border,
          width: '100%',
          boxSizing: 'border-box',
        }}>
        <Grid container direction="row">
          <Grid item xs>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              width="100%"
              pl={custom.spacing.md}
              pr={custom.spacing.sm}>
              <Grid item xs={12} pt={custom.spacing.md} pb={custom.spacing.xs}>
                <Typography component={'h1'} variant="szHeading.Bold.Large" noWrap>
                  Your system
                </Typography>
              </Grid>
              <Grid item xs={12} justifyContent={'center'}>
                <Box
                  component={'img'}
                  sx={{
                    display: {
                      xs: 'block',
                      sm: 'none',
                      md: 'none',
                      lg: 'none',
                    },
                  }}
                  mt={1}
                  height="auto"
                  width={'200px'}
                  loading="lazy"
                  alt="System Image"
                  src="/images/SystemInfo.svg"
                />
              </Grid>
              <Grid item xs={12} py={custom.spacing.xs}>
                <Typography variant="szBody.Regular.Small" noWrap>
                  Device name
                </Typography>
                <Typography component="p" id="deviceName" color="text.secondary" variant="szBody.Regular.Small" noWrap>
                  {data?.system?.deviceName}
                </Typography>
              </Grid>
              <Grid item xs={12} py={custom.spacing.xs}>
                <Typography variant="szBody.Regular.Small">Battery capacity</Typography>
                <Typography
                  component="p"
                  color="text.secondary"
                  id="batteryCapacity"
                  variant="szBody.Regular.Small"
                  noWrap>
                  {data?.dashboard?.monitor?.battery?.capacity} kW
                </Typography>
              </Grid>
              <Grid item xs={12} py={custom.spacing.xs}>
                <Typography variant="szBody.Regular.Small" noWrap>
                  Device serial
                </Typography>
                <Typography
                  component="p"
                  color="text.secondary"
                  id="deviceSerial"
                  variant="szBody.Regular.Small"
                  noWrap>
                  {data?.system?.deviceSerial}
                </Typography>
              </Grid>
              <Grid item xs={12} py={custom.spacing.xs}>
                <Typography variant="szBody.Regular.Small" noWrap>
                  Monitoring installed date
                </Typography>
                <Typography
                  component="p"
                  color="text.secondary"
                  id="installedDate"
                  variant="szBody.Regular.Small"
                  noWrap>
                  {`${data?.system?.installedDate ? moment(data?.system?.installedDate).format('ll') : ''}`}
                </Typography>
              </Grid>
              {data?.customer?.account?.activationDate && (
                <Grid item xs={12} py={custom.spacing.xs}>
                  <Typography variant="szBody.Regular.Small" noWrap>
                    Activation date
                  </Typography>
                  <Typography
                    component="p"
                    color="text.secondary"
                    id="installedDate"
                    variant="szBody.Regular.Small"
                    noWrap>
                    {moment(data?.customer?.account?.activationDate).format('ll')}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} py={custom.spacing.xs}>
                <Typography variant="szBody.Regular.Small" noWrap>
                  Running status
                </Typography>
                <Stack alignItems="start" direction="row" justifyContent="flex-start">
                  <CircleIcon
                    sx={{
                      height: '1.25rem',
                      color: `${data?.system?.online ? 'success.main' : 'warning.main'}`,
                    }}
                  />
                  <Typography sx={{ color: 'text.secondary' }} id="deviceStatus" variant="szBody.Regular.Small">
                    {data?.system?.online ? 'Online' : 'Offline'}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs>
            <Grid container direction="column" justifyContent={'center'} alignItems={'center'}>
              <Grid item xs={12}>
                <Box
                  component={'img'}
                  mt={10}
                  sx={{
                    display: {
                      xs: 'none',
                      sm: 'flex',
                      md: 'flex',
                      lg: 'flex',
                    },
                  }}
                  height="auto"
                  width="250px"
                  loading="lazy"
                  alt="System Image"
                  src="/images/SystemInfo.svg"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}